import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
// import UserProfile from '../Configuration/UserProfile.js';

class ChangePassword extends Component {
    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatePasswordFormat = this.validatePasswordFormat.bind(this);
        this.validateConfirmation = this.validateConfirmation.bind(this);

        this.state = {
            return_success: false,
            return_failure: false,
            password_is_valid: false,
            password_style_valid: true,
            password_is_confirmed: false,
            password_style_is_confirmed: true,
            password: ''
        }
    }

    handleSubmit(event) {
        event.preventDefault();

        var that = this;
        const data = {
            op: event.target.elements.CurrentPassword.value,
            np: event.target.elements.NewPassword.value
        }

        fetch(config.getUriPath('identity/password/change'), {
            method: 'post',
            headers: config.ApiHeaders(),
            body: JSON.stringify(data)
           }).then(function(response) {
            if (response.status === 200) {
                that.setState({return_failure: false, return_success: true});
            } else {
                that.setState({return_failure: true, return_success: false});
            }
          });
    }

    validatePasswordFormat(e) {
        const password = e.target.value;
        if(password.length < 8 || 
           /[A-Z]+/.test(password) === false || 
           /[!@#\$%\^\&*\)\(+=._-]/.test(password) === false || 
           /[0-9]+/.test(password) === false) {
            return this.setState({password_is_valid: false, password_style_valid: false});
        }

        return this.setState({password_is_valid: true, password_style_valid: true, password: password});
    }

    validateConfirmation(e) {
        if(e.target.value === this.state.password) {
            this.setState({password_is_confirmed: true, password_style_is_confirmed: true});
        } else {
            this.setState({password_is_confirmed: false, password_style_is_confirmed: false});
        }
    }

    render() {
        return <div>
                    <div className="center-div">
                        <h1>Change Your Password</h1>
                    </div>
                    <br />
                    <div className="form-wrapper">
                        <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                                <label htmlFor="CurrentPassord">Current Password:</label>
                                <input 
                                    name="CurrentPassword" 
                                    type="password"
                                    placeholder="Current Password"
                                    className="form-control" /><br/>
                                <label htmlFor="NewPassord">New Password:</label>
                                <input 
                                    name="NewPassword" 
                                    type="password"
                                    placeholder="New Password"
                                    onChange={this.validatePasswordFormat}
                                    className={this.state.password_style_valid ? "form-control" : "form-control is-invalid"} /><br/>
                                <label htmlFor="NewPassord2">Re-type Password:</label>
                                <input 
                                    name="NewPassword2" 
                                    type="password"
                                    placeholder="Re-type Password"
                                    onChange={this.validateConfirmation}
                                    className={this.state.password_style_is_confirmed ? "form-control" : "form-control is-invalid"} /><br/>
                                <div style={{ lineHeight: "1.4"}}>Passwords must be at least 8 characters and must contain at least 1 upper-case letter, 1 number, and 1 non-alphanumeric character</div>
                                <br/>
                                <button className="loginButton btn btn-primary">Change Password</button>
                            </div>
                            <div className={this.state.return_success ? "errorMsg alert alert-success" : "hidden alert alert-success"}>Password successfully changed</div>
                            <div className={this.state.return_failure ? "errorMsg alert alert-danger" : "hidden alert alert-danger"}>An error occurred changing your password</div>
                        </form>
                    </div>
            </div>
    }
}

export default ChangePassword


// WEBPACK FOOTER //
// ./src/Components/User/ChangePassword.js